module.exports = __webpack_public_path__ + "static/media/ptm_logo.b98fa46d.png";